import React, { useState, useEffect, useContext } from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import withWidth from '@material-ui/core/withWidth';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { API } from 'aws-amplify';

import { appointmentContext } from '../provider/Times'
import LoadingDialog from './LoadingDialog';

const options = { weekday: 'short', month: 'numeric', day: 'numeric' };
const useStyles = makeStyles((theme) => ({
  header: {
    margin: theme.spacing(1)
  },
  paper: {
    //height: 400,
    height: '100%',
    //padding: theme.spacing(1),
    minWidth: '136px',
    overflowY: 'hidden'
  },
  paperContent: {
    //height: 350,
    maxHeight: 350,
    padding: theme.spacing(1),
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  padding: {
    padding: "4px"
  },
  iconRight: {

  },
  iconLeft: {
    //float: 'right'
  }
}))

export const Carousel = withWidth() ((props) => {
  const classes = useStyles();
  const { elements, width } = props;
  const nItems = {
    xs: 1,
    sm: 3,
    md: 5,
    lg: 5,
    xl: 5,
  }
  const pageSize = nItems[width] || 5;
  const [page, setPage] = useState(0);
  const from = page * pageSize
  const to = pageSize + page * pageSize;
  const items = elements.slice (from , to)
  const nextPage = () => {
    setPage (page+1)
  }
  const prevPage = () => {
    setPage(page-1)
  }

  return <center className={classes.padding}>
    <Grid container justify="center" spacing={1}>
      <Grid item>
        <IconButton className={classes.iconLeft} onClick={prevPage} disabled={page===0}><ArrowBackIcon></ArrowBackIcon></IconButton>
      </Grid>
      {items}
      <Grid item>
        <IconButton className={classes.iconRight} onClick={nextPage} disabled={elements.length <= to}><ArrowForwardIcon></ArrowForwardIcon></IconButton>
      </Grid>
    </Grid>
  </center>
})

const reduceToLkp = (lkp, entry) => {
  var date = new Date(entry.from);
  var lkpStr = date.toLocaleDateString('de-DE', options);
  return {
    ...lkp,
    [lkpStr]: [
      ...(lkp[lkpStr] || []),
      entry
    ]
  }
}
const TimePicker = () => {
  const { data: entries, isPending, select } = useContext(appointmentContext)
  const lkp = entries.reduce (reduceToLkp, {});

  if (isPending) {
    return [<LoadingDialog>
          Freie Termine werden geladen.
    </LoadingDialog>]
  }

  return Object.keys (lkp).map ((key) => {
    const list = lkp[key];
    return <DayEntry header={key} entries={list}></DayEntry>
  })
}



const DayEntry = (props) => {
  const classes = useStyles();
  const { date, entries = [], header } = props
  const { selected, select } = useContext (appointmentContext);

  return <Grid item>
    <Paper className={classes.paper}>
      <Typography className={classes.header} variant="h5">{header}</Typography>
      <hr></hr>
      <div className={classes.paperContent}>
        <Grid container direction="column" spacing={1}>
          {entries.map ((ts) => {
            const date = new Date(ts.from);
            const timStr = date.toTimeString().split (":").slice(0,2).join(':');
            const sel = selected === ts.from;
            const c = sel?'primary':'default';
            return <Grid item>
              <center>
                <Chip onClick={() => {
                  select (ts.from);
                }} color={c} label={timStr}></Chip>
              </center>
            </Grid>
          })}
        </Grid>
      </div>
    </Paper>
  </Grid>
}

export default TimePicker;